export default [
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: () => import('@/views/admin/management/Dashboard.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Dashboard',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Dashboard',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/prebid',
    name: 'admin-prebid',
    component: () => import('@/views/admin/management/Prebid.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Prebid',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Prebid',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/errordashboard',
    name: 'admin-errordashboard',
    component: () => import('@/views/admin/management/ErrorDashboard.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.ErrorDashboard',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.ErrorDashboard',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/accounts',
    name: 'admin-accounts',
    component: () => import('@/views/admin/management/Accounts.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Accounts',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Accounts',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/ads',
    name: 'admin-ads',
    component: () => import('@/views/admin/management/Ads.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Ads',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Ads',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/transactions',
    name: 'admin-transactions',
    component: () => import('@/views/admin/management/Transactions.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Transactions',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Transactions',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('@/views/admin/management/Users.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Users',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Users',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/withdraws',
    name: 'admin-withdraws',
    component: () => import('@/views/admin/management/Withdraws.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Withdraws',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Withdraws',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/properties',
    name: 'admin-properties',
    component: () => import('@/views/admin/management/Properties.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Properties',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Properties',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/dailycosts',
    name: 'admin-dailycosts',
    component: () => import('@/views/admin/management/DailyCosts.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.DailyCosts',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.DailyCosts',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/performance-report',
    name: 'admin-performance-report',
    component: () => import('@/views/admin/management/PerformanceReport.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.PerformanceReport',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.PerformanceReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/whitelist-blacklist',
    name: 'admin-whitelist-blacklist',
    component: () => import('@/views/admin/management/WhitelistBlacklist.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Whitelist/Blacklist',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Whitelist/Blacklist',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/create-whitelist-blacklist',
    name: 'admin-create-whitelist-blacklist',
    component: () => import('@/views/admin/management/CreateAccountPropertyTargeting.vue'),
    props: () => ({
      catalogId: '0',
    }),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.Create',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.Create',
          active: true,
        },
      ],
    },
  },
]
